import { DARK_PRIMARY_TEXT_COLOR, FTV_DARK_PRIMARY_ACTIVE_BACKGROUND_COLOR, FTV_DARK_PRIMARY_BACKGROUND_COLOR, FTV_DARK_PRIMARY_HOVER_BACKGROUND_COLOR } from '../../../theme/colors';
import { SKIP_BTN_STYLE_FOCUS_HOVER } from '../../common/buttons/styles';
import { BASE_STYLE } from '../../common/titles/styles';

export const SKIP_BUTTON_ACTIVE = {
  default: {
    backgroundColor: FTV_DARK_PRIMARY_ACTIVE_BACKGROUND_COLOR
  },
  'largeTv+extraLargeTv': SKIP_BTN_STYLE_FOCUS_HOVER
};

export const SKIP_BUTTON_HOVER = {
  default: {
    backgroundColor: FTV_DARK_PRIMARY_HOVER_BACKGROUND_COLOR
  }
};

export const SKIP_BUTTON_CUSTOM_FONT = {
  small: {
    fontSize: '12px'
  },
  extraLarge: {
    fontSize: '20px'
  }
};

export const PLAYER_BUTTON_STYLE = {
  default: { display: 'flex', ...BASE_STYLE.default, width: 'max-content', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', padding: '0px 16px' },
  smallContainer: { height: '32px' },
  mediumContainer: { height: '36px' },
  largeContainer: { height: '44px', padding: '0px 20px' },
  extraLargeContainer: { height: '48px', padding: '0px 20px' }
};

export const PLAYER_BUTTON_DARK_STYLE = {
  ...PLAYER_BUTTON_STYLE,
  default: {
    ...PLAYER_BUTTON_STYLE.default,
    backgroundColor: FTV_DARK_PRIMARY_BACKGROUND_COLOR,
    color: DARK_PRIMARY_TEXT_COLOR
  }
};
